import { render, staticRenderFns } from "./CautionCard.vue?vue&type=template&id=2e4abfcc&scoped=true"
import script from "./CautionCard.vue?vue&type=script&lang=js"
export * from "./CautionCard.vue?vue&type=script&lang=js"
import style0 from "./CautionCard.vue?vue&type=style&index=0&id=2e4abfcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4abfcc",
  null
  
)

export default component.exports